<template>
    <v-row style="width: 28%; margin-top: 110px;">
      <Skeleton 
        height="53px"
        class="mx-3 mt-3 custom-skeleton" 
        animation="wave"
      />
    </v-row>
    <v-row style="width: 28%;">
      <Skeleton 
        height="53px" 
        width="100vw"
        class="mx-3  mt-3 custom-skeleton" 
        animation="wave"
      />
    </v-row>
    <v-row style="width: 28%;">
      <Skeleton 
        height="53px" 
        width="100vw"
        class="mx-3  mt-3 custom-skeleton" 
        animation="wave"
      />
    </v-row>
    <v-row style="width: 28%;">
      <Skeleton 
        height="53px" 
        width="100vw"
        class="mx-3  mt-3 custom-skeleton" 
        animation="wave"
      />
    </v-row>
    <v-row style="width: 28%;">
      <Skeleton 
        height="53px" 
        width="100vw"
        class="mx-3  mt-3 custom-skeleton" 
        animation="wave"
      />
    </v-row>
    <v-row style="width: 28%;">
      <Skeleton 
        height="53px" 
        width="100vw"
        class="mx-3  mt-3 custom-skeleton" 
        animation="wave"
      />
    </v-row>
    <v-row style="width: 28%;">
      <Skeleton 
        height="53px" 
        width="100vw"
        class="mx-3  mt-3 custom-skeleton" 
        animation="wave"
      />
    </v-row>
    <v-row style="width: 28%;">
      <Skeleton 
        height="53px" 
        width="100vw"
        class="mx-3  mt-3 custom-skeleton" 
        animation="wave"
      />
    </v-row>
    <v-row style="width: 28%;">
      <Skeleton 
        height="53px" 
        width="100vw"
        class="mx-3  mt-3 custom-skeleton" 
        animation="wave"
      />
    </v-row>
  </template>
  
  <script>
  import Skeleton from "primevue/skeleton";
  export default {
    components: { Skeleton },
  };
  </script>
  
  <style>
  .custom-skeleton::after {
    background: linear-gradient(
        90deg,
        rgba(18, 88, 171, 0) 0%,        
        rgba(18, 88, 171, 0.4) 50%,      
        rgba(18, 88, 171, 0) 100%        
    ) !important;
  }
  </style>